<!-- Splash Screen -->
<app-splash-screen [visible]="splashVisible" [fadeOut]="splashFadeOut"></app-splash-screen>

<router-outlet></router-outlet>

<!-- Global Action Modal -->
@if (actionModal$ | async; as modal) {
  <app-action-modal
    [trigger]="modal.isOpen"
    [title]="modal.title | translate"
    [description]="modal.message | translate: (modal.messageParams ?? undefined)"
    [action_state]="modal.actionState | translate"
    (cancel)="onModalCancel(modal)"
    (confirm)="onModalConfirm(modal)">
  </app-action-modal>
}

<!-- Global Info Modal (cannot delete / warning) -->
@if (infoModal$ | async; as info) {
  @if (info.isOpen) {
    <div class="fixed inset-0 bg-black/20 flex items-center justify-center z-50">
      <div class="p-5 flex flex-col gap-5 rounded-lg w-115 bg-white border border-border_color">
        <div class="flex flex-col items-center gap-4">
          <div class="p-3 rounded-full bg-[rgba(220,38,38,0.1)] flex items-center justify-center">
            <img src="assets/icons/alert_circle_red_icon.svg" alt="" width="24" height="24" />
          </div>
          <div class="flex flex-col gap-2.5">
            <h2 class="text-lg font-semibold text-center text-text_dark">{{ info.title | translate }}</h2>
            <p class="text-center text-sm text-text_gray">{{ info.message | translate: (info.messageParams ?? undefined) }}</p>
          </div>
        </div>
        <button (click)="closeInfoModal()" class="flex items-center justify-center py-2.5 px-3 bg-primary_color rounded-lg text-white text-sm w-full">
          {{ 'common.close' | translate }}
        </button>
      </div>
    </div>
  }
}

<app-toast></app-toast>
